export default "__VITE_ASSET__0a97427c__"